// delay between new API calls in ms when typing in filter inputs
export const TYPING_INTERVAL = 650
